import { render, staticRenderFns } from "./ot-date-picker-wrapper.vue?vue&type=template&id=57212dba&scoped=true&"
import script from "./ot-date-picker-wrapper.vue?vue&type=script&lang=ts&"
export * from "./ot-date-picker-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ot-date-picker-wrapper.vue?vue&type=style&index=0&id=57212dba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57212dba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
